<div class="left-main-div">
  <div class="section-content">
    <p class="heading heading-light">Welcome,</p>
    <p class="heading heading-bold">{{ (userProfile.firstName) | titlecase }}</p>
    <p class="description padding-tb">
      Complete these activities to unlock a career plan built around your strengths and goals. 
      The more activities you complete, the better your career matches will be.
    </p>

    @for (item of sortedChecklist; track $index) {
      @if (item.status == "completed") {
        <div class="checklist-wrapper">
          <div class="checklist-tab">
            <img 
              src='/assets/icons/teal-tick.svg' 
              alt="tick"
            />
            <div class="checklist-item">
              <div class="item-header-div">
                <p class="item-text">{{ item.title }}</p>
              </div>
            </div>
          </div>
          <img 
            [src]="`/assets/icons/results/line-${
                $index == 0 ? 'start' : 
                $index == lastCheckListItemIndex ? 
                'end' : 'middle' 
              }.svg`"
            alt="line"
            [class]="`${$index !== 0 && $index !== lastCheckListItemIndex ? 'middle-line' : ''}`"
          />
        </div>
      } @else {
        <div 
          class="checklist-tab checklist-todo" 
          (click)="onClickItem(item.tag)"
          (keydown.enter)="onClickItem(item.tag)"
          (keydown.space)="$event.preventDefault(); onClickItem(item.tag)"
          [class]="`${item.status == 'locked' ? 'checklist-locked' : ''}`"
          [matTooltip]="`${item.status == 'locked' ? item.hover : ''}`"
          matTooltipPosition="below"
          tabindex="0"
          role="button"
        >
          <div [class]="`${item.status != 'locked' ? 'icon-wrapper' : ''}`">
            <img 
              [src]="`/assets/icons/${item.status == 'locked' ? 'todo-locked' : 'todo-circle'}.svg`"
              alt="todo"
            />
          </div>
          <div class="checklist-item">
            <div class="item-header-div">
              <p class="item-header">{{ item.title }}</p>
              <p class="item-subheader">{{ item.time }}</p>
            </div>
            @if (item.status == "todo") {
              <button class="badge" tabindex="0">
                <p>{{ item.statusText }}</p>
              </button>
              <p class="description">
                {{ item.description }} 
              </p>
            }
          </div>
        </div>
      }
    }
  </div>
</div>
